const BrowserBaseURL = process.env.REACT_APP_API_BASE_URL || 'https://api.smartsalary.cn';
const PosthogApiKey = 'phc_daviSTk7X7MlAotUyPST1O8kqcxpXfj5GGQr9gjQfr7';
const PosthogApiHost = 'https://app.posthog.com';

export default BrowserBaseURL;
export { PosthogApiKey, PosthogApiHost };
